module.exports = __webpack_public_path__ + "img/canbadge_gokaku_60mm_line.5553ae7d.png";